import Vue from 'vue';
import App from './App';
import router from './router';
import 'element-ui/lib/theme-chalk/index.css';

import ElementUi from 'element-ui';
import store from './store/index.js';
import '@wangeditor/editor/dist/css/style.css';

import './icons';

import mForm from '@/components/mForm';
import mTable from '@/components/mTable';
import PageHead from "@/components/pageHead";
import mixin from '@/common/mixin';

Vue.config.productionTip = false;
Vue.use(ElementUi);
Vue.component('x-form', mForm);
Vue.component('x-table', mTable);
Vue.component('page-head', PageHead);

Vue.config.productionTip = false;

Vue.mixin(mixin);

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app');
